import type { SpaceTypeEnum } from 'src/common/external/bambi-api/bambiApi';
import { AmbulatoryIcon } from 'src/common/primitives/icon/AmbulatoryIcon';
import { StretcherIcon } from 'src/common/primitives/icon/StretcherIcon';
import { WheelchairIcon } from 'src/common/primitives/icon/WheelchairIcon';

type SpaceTypeIconMap = {
  [t in SpaceTypeEnum]: (props: any) => JSX.Element;
};

export const SpaceTypeIcons: SpaceTypeIconMap = {
  'wheelchair xl': WheelchairIcon,
  wheelchair: WheelchairIcon,
  stretcher: StretcherIcon,
  ambulatory: AmbulatoryIcon,
  'broda chair': WheelchairIcon,
  'geri chair': WheelchairIcon,
} as const;
